import { STORAGE_KEYS } from '../config.ts';

/**
 * Merkmale eines bevorzugten Abspielgeraets.
 *
 * Spotify vergibt Mobilgeraeten bei jedem App-Neustart teils neue IDs, der
 * Name bleibt dagegen stabil. Deshalb ist der Name der eigentliche Schluessel,
 * die ID nur ein zusaetzlicher Treffer-Hinweis.
 */
export interface DevicePreference {
  name: string;
  id: string | null;
  type: string;
}

export interface Settings {
  /** Wunschgeraet, normalerweise das iPad, auf dem Spotibox laeuft. */
  primaryDevice: DevicePreference | null;
  /** Ersatzgeraet, wenn das Wunschgeraet nicht erreichbar ist (z. B. Alexa). */
  fallbackDevice: DevicePreference | null;
  /** Obergrenze fuer die Lautstaerke, die das Kind einstellen kann. */
  maxVolumePercent: number;
  /** Ab diesem Anteil gilt eine Folge als gehoert. */
  finishedThreshold: number;
  /** Beim Fortsetzen so viel zuruecksprigen, damit der Faden wiedergefunden wird. */
  resumeRewindMs: number;
  /** Foto der Eltern als Data-URL fuer den „Hol einen Erwachsenen"-Bildschirm. */
  grownUpPhoto: string | null;
}

export const DEFAULT_SETTINGS: Settings = {
  primaryDevice: null,
  fallbackDevice: null,
  maxVolumePercent: 70,
  finishedThreshold: 0.92,
  resumeRewindMs: 5000,
  grownUpPhoto: null,
};

export function loadSettings(): Settings {
  const raw = localStorage.getItem(STORAGE_KEYS.settings);
  if (!raw) return { ...DEFAULT_SETTINGS };
  try {
    const parsed = JSON.parse(raw) as Partial<Settings>;
    return { ...DEFAULT_SETTINGS, ...parsed };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(settings: Settings): void {
  localStorage.setItem(STORAGE_KEYS.settings, JSON.stringify(settings));
}
